import { handleActions } from 'redux-actions';

import { currentUserSet } from './action';
import { State } from './type';

const initialState: State = {
  currentUser: null,
};

const reducer = handleActions(
  {
    [String(currentUserSet)]: (state, { payload }) => {
      return {
        ...state,
        currentUser: payload as unknown as State['currentUser'],
      };
    },
  },
  initialState,
);

export default reducer;
